<template>
    
    <!-- Navbar -->
    <nav class="navbar-wrapper">

        <!-- Mini Cart Component -->
        <MiniCart ref="mini-cart"/>

            <!-- Nav Main Bar -->
            <div class="nav-main-bar-wrapper">
                <div class="nav-main-bar">
                    <div class="nav-main-left-wrapper">
                        <div class="nav-main-left">
                            <!-- Hamburger -->
                            <svg class="nav-hamburger" @click="toggleSideBar()" xmlns="http://www.w3.org/2000/svg"><path d="M-0,8L-0,6L18,6L18,8L-0,8ZM-0,-0L18,-0L18,2L-0,2L-0,-0ZM14,14L-0,14L-0,12L14,12L14,14Z" fill="#3a3a3a"></path></svg>
                            <!-- Logo -->
                            <a href="/">
                                <img class="nav-logo" src="https://firebasestorage.googleapis.com/v0/b/flikbox-2606.appspot.com/o/assets%2Fimages%2Flogos%2Flogo-320.png?alt=media" alt="Flikbox Logo">
                                <span class="nav-logo-text">Flikbox</span>
                            </a>

                            <SideBar ref="sidebar" :sideBarData="sideBarData"/>

                            <!-- Nav Menu -->
                            <div class="nav-category-bar">
                                <ul class="nav-category-list-box">
                                    <li class="nav-category-list-item" v-for="item in category_data" :key="item.category_name">
                                        <a :href="'/collection/'+item.id"><p class="nav-category-list-text">{{item.category_name}}</p></a>
                                        <div class="nav-category-outer" v-if="item.sublist_data!=undefined">
                                            <div class="nav-category-sublist-box-wrapper">
                                                <div class="nav-category-sublist-box">

                                                    <div class="sublist-item-col-wrapper">
                                                        <div class="sublist-item-col" v-for="category in item.sublist_data.text_data_list" :key="category.sub_category_title">
                                                        <a :href="'/collection/'+category.id"><h4 class="sublist-item-header font-semibold mb-4">{{category.sub_category_title}}</h4></a>
                                                        <ul>
                                                            <li v-for="subcategory in category.sub_category_data" class="sublist-item-text" :key="subcategory.name">
                                                                <a v-if="subcategory.gender!=undefined" :href="'/collection/'+subcategory.id+'?gender='+subcategory.gender">{{subcategory.name}}</a>
                                                                <a v-if="subcategory.gender==undefined" :href="'/collection/'+subcategory.id">{{subcategory.name}}</a>
                                                            </li>
                                                        </ul>
                                                        </div>
                                                    </div>

                                                    <div class="image-sublist-container">
                                                        <div class="image-sublist-item" v-for="image_category in item.sublist_data.image_data_list" :key="image_category.title">
                                                            <a :href="image_category.url">
                                                                <div class="image-sublist-wrapper">
                                                                    <img class="image-sublist-img" :src="image_category.image">
                                                                </div>
                                                                <p class="image-sublist-title">{{image_category.title}}</p>
                                                                <p class="image-sublist-text">{{image_category.desc}}</p>
                                                            </a>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="nav-main-right-wrapper">
                        <div class="nav-main-right">
                            <!-- Nav Search Box -->
                            <div class="nav-search-box-wrapper">
                                <div class="nav-search-box" :style="navSearchStyle">
                                    <input type="text" placeholder="Search for products" class="nav-search-input" @keyup="performSearch()" @focus="searchInputFocus()" @blur="searchInputBlur()" v-model="searchVal">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="nav-search-icon" fill="none" viewBox="0 0 24 24" stroke="#a0a4a9"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.3" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path></svg>
                                    
                                    <div class="nav-search-dropdown-wrapper" :style="searchDropdownStyle">
                                        <div id="nav-search-dropdown" class="nav-search-dropdown">
                                            <div class="search-result-box">
                                                <div class="nav-search-result-item" v-for="res in searchResult" :key="res.item.name">
                                                    <a :href="'/product/'+res.item.id"><span class="nav-search-dd-text">{{res.item.name}}</span></a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <!-- Portrait Search Box -->
                            <svg xmlns="http://www.w3.org/2000/svg" class="nav-search-icon-portrait" @click="showPortraitSearchBox()" fill="none" viewBox="0 0 24 24" stroke="#a0a4a9"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.3" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path></svg>
                            <div class="portrait-search-box-wrapper hidden" id="portrait-search-box" :style="portraitSearchStyle">
                                <div class="portrait-search-box">
                                    <input class="input-box portrait-input-box" type="" name="" placeholder="Search Product" v-model="searchVal" @keyup="performSearch()" @blur="searchInputBlur()">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="search-close-icon-svg" @click="hidePortraitSearchBox()" width="20" height="20"><path d="M16.7,16.7L16.7,16.7c-0.4,0.4-1,0.4-1.4,0L10,11.4l-5.3,5.3c-0.4,0.4-1,0.4-1.4,0l0,0c-0.4-0.4-0.4-1,0-1.4L8.6,10L3.3,4.7c-0.4-0.4-0.4-1,0-1.4l0,0c0.4-0.4,1-0.4,1.4,0L10,8.6l5.3-5.3c0.4-0.4,1-0.4,1.4,0l0,0c0.4,0.4,0.4,1,0,1.4L11.4,10l5.3,5.3C17.1,15.7,17.1,16.3,16.7,16.7z" fill="#b2b2b2"></path></svg>
                                    <div class="nav-search-dropdown-wrapper-portrait" :style="portraitSearchDropdownStyle">
                                        <div id="nav-search-dropdown" class="nav-search-dropdown">
                                            <div class="search-result-box">
                                                <div class="nav-search-result-item" v-for="res in searchResult" :key="res.item.name">
                                                    <a :href="'/product/'+res.item.id"><span class="nav-search-dd-text">{{res.item.name}}</span></a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- Nav Account Icon -->
                            <div class="nav-account-box" @click="goToMyAccount()">
                                <svg xmlns="http://www.w3.org/2000/svg" class="nav-account-icon" fill="none" viewBox="0 0 24 24" stroke="#909090"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.3" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/></svg>
                            </div>
                            <!-- Nav Cart Icon -->
                            <div class="nav-cart-box" @click="showMiniCart()">
                                <svg xmlns="http://www.w3.org/2000/svg" class="nav-cart-icon" fill="none" viewBox="0 0 24 24" stroke="#909090"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.3" d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" /></svg>
                                <span class="cart-item-count">{{cartItemCount}}</span>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

    </nav>

</template>

<script>
import Fuse from 'fuse.js'
import firebase from 'firebase';
import SideBar from '@/components/navigation/SideBar.vue'
import MiniCart from '@/components/navigation/MiniCart.vue'
import { getCollectionFileUrl } from "@/apis/navigation";
import { getCollectionFile } from "@/apis/navigation";


export default {
    name: 'Navbar',
    components: { SideBar, MiniCart },
    data(){
        return{
            email: undefined,
            uid: undefined,
            navSearchStyle: {},
            searchDropdownStyle: {},
            portraitSearchDropdownStyle: {},
            portraitSearchStyle: {},
            cartItemCount: 0,
            searchVal: '',
            searchResult: [],
            collectionsList: [],
            category_data: [{"category_name":"Men","id": "men","sublist_data":{"text_data_list":[{"sub_category_title":"Top Wear","id":"mens-top-wear","sub_category_data":[{"name":"T-shirts","id":"tshirt", "gender": "men"},{"name":"Full Sleeve T-Shirts","id":"full-sleeve", "gender": "men"},{"name":"Baseball T-Shirts","id":"baseball", "gender": "men"},{"name":"V-Neck T-Shirts","id":"vneck", "gender": "men"},{"name":"Polo T-Shirts","id":"polo", "gender": "men"},{"name":"Tank Tops","id":"tanks", "gender": "men"},{"name":"Muscle Shirts","id":"muscle", "gender": "men"},{"name":"Denim","id":"denim", "gender": "men"}]},{"sub_category_title":"Jackets & Hoodies","id":"mens-jackets-and-hoodies","sub_category_data":[{"name":"Bomber Jackets","id":"bomber-jacket", "gender": "men"},{"name":"Letterman Jackets","id":"letterman-jacket", "gender": "men"},{"name":"Denim Jackets","id":"denim-jacket", "gender": "men"},{"name":"Fleece Jacket","id":"fleece-jacket", "gender": "men"},{"name":"Hoodies","id":"hoodie", "gender": "men"},{"name":"Sweat Shirts","id":"sweatshirt", "gender": "men"},{"name":"Zip Hoodies","id":"zip-hoodie", "gender": "men"},{"name":"Tie-Dye Hoodies","id":"tie-dye-hoodie", "gender": "men"}]},{"sub_category_title":"Bottom Wear","id":"mens-bottom-wear","sub_category_data":[{"name":"Joggers","id":"jogger", "gender": "men"},{"name":"Shorts","id":"shorts", "gender": "men"},{"name":"Leggings","id":"legging", "gender": "men"},{"name":"Boxer Briefs","id":"briefs", "gender": "men"}]}],"image_data_list":[{"image":"https://cdn.shopify.com/s/files/1/0932/1356/products/LongsleevePocketCrewBlack_1600x_crop_center.jpg","title":"Exciting Offers","desc":"Upto 20% off","url":"#"},{"image":"https://cdn.shopify.com/s/files/1/0167/4484/products/main-1_800x.jpg","title":"Exciting Offers","desc":"Special discount","url":"#"}]}}, {"category_name":"Women","id": "women","sublist_data":{"text_data_list":[{"sub_category_title":"Top Wear","id":"womens-top-wear","sub_category_data":[{"name":"T-shirts","id":"tshirt", "gender": "women"},{"name":"Polo T-shirts","id":"polo", "gender": "women"},{"name":"Crop Top","id":"crop-top", "gender": "women"},{"name":"Sweatshirts","id":"sweatshirt", "gender": "women"},{"name":"Tank Tops","id":"tanks", "gender": "women"},{"name":"Jackets","id":"jacket", "gender": "women"},{"name":"Hoodies","id":"hoodie", "gender": "women"},{"name":"Dress","id":"dress", "gender": "women"}]},{"sub_category_title":"Bottom Wear","sub_category_url":"#","sub_category_data":[{"name":"Shorts","id":"shorts", "gender": "women"}, {"name":"Skirts","id":"skirt", "gender": "women"},{"name":"Leggings","id":"legging", "gender": "women"},{"name":"Joggers","id":"jogger", "gender": "women"}]},{"sub_category_title":"Inner wear","sub_category_url":"#","sub_category_data":[{"name":"Sports Bra","id":"bra", "gender": "women"},{"name":"Swimwear","id":"swimwear"}]}],"image_data_list":[{"image":"https://firebasestorage.googleapis.com/v0/b/flikbox-2606.appspot.com/o/assets%2Fimages%2Fproducts%2Fflik-women-sports-bra-white%2F3.png?alt=media","title":"Flik Women Sports Bra - White","desc":"Upto 20% off","url":"#"},{"image":"https://cdn.shopify.com/s/files/1/0932/1356/products/CrewSockBlack_1_5917054a-7fae-4e2d-a437-992ba283b1ac_800x.jpg","title":"Exciting Offers","desc":"Special discount","url":"#"}]}}, /*{"category_name":"Accessories","sublist_data":{"text_data_list":[{"sub_category_title":"Home & Living","sub_category_url":"#","sub_category_data":[{"name":"Bottles & Mugs","id":"bottle-mug"},{"name":"Aprons","id":"apron"},{"name":"Pet Products","id":"pet-product"},{"name":"Posters & Postcards","id":"poster-postcard"},{"name":"Pillows","id":"pillow"},{"name":"Towels & Blankets","id":"towel-blanket"},{"name":"Wall Art","id":"wall-art"},{"name":"Bean Bags","id":"bean-bag"},{"name":"Flags","id":"flags"}]},{"sub_category_title":"Accessories","sub_category_url":"#","sub_category_data":[{"name":"Cases & Stickers","id":"case-sticker"},{"name":"Face Masks","id":"face-mask"},{"name":"Key Chains","id":"phone-case"},{"name":"Bags & Backpacks","id":"bags"},{"name":"Flipflops","id":"flipflop"},{"name":"Jewelry","id":"jewelry"},{"name":"Socks","id":"socks"},{"name":"Fanny Packs","id":"fanny-pack"}]}, {"sub_category_title":"Caps & Hats","sub_category_url":"#","sub_category_data":[{"name":"Baseball Caps","id":"baseball-cap"},{"name":"Trucker Caps","id":"trucker-cap"},{"name":"Bucket Hats","id":"bucket-hat"},{"name":"Beanie","id":"beanie"},{"name":"Visors","id":"visor"}]}],"image_data_list":[{"image":"https://cdn.shopify.com/s/files/1/0167/4484/files/dropdown-objects_x500.jpg","title":"Exciting Offers","desc":"Upto 20% off","url":"#"},{"image":"https://cdn.shopify.com/s/files/1/0167/4484/products/kinto-8_800x.jpg","title":"Exciting Offers","desc":"Special discount","url":"#"}]}}, */{"category_name": "Collections","id": "all"}],
            sideBarData: ["T-shirts", "Crypto", "Flutter", "Programming", "Python"]
        }
    },
    mounted(){
        document.getElementsByTagName("body")[0].addEventListener("click", this.hideSearchResults);
        this.checkAuthentication();
        this.getCollection();
        this.getCartItems();
    },
    methods:{
        checkAuthentication(){
            let self = this;
            firebase.auth().onAuthStateChanged((user) => {
                if (user != null) {
                   self.email = user.email;
                   self.uid = user.uid;
                }
            });
        },
        // Get Collection Data from Firebase Storage
        async getCollection(){
            let currentTime = Math.floor(Date.now() / 1000);
            let collectionsLastUpdated = localStorage.getItem("collectionsLastUpdated");
            if((collectionsLastUpdated == null) || (currentTime-collectionsLastUpdated)>86400){
                let self = this;
                let url = await getCollectionFileUrl('assets/files/collection/all.json');
                this.collectionsList = await getCollectionFile(url);

                localStorage.setItem("collections", JSON.stringify(self.collectionsList));
                localStorage.setItem("collectionsLastUpdated", currentTime);
            }
            else{
                this.collectionsList = JSON.parse(localStorage.getItem("collections"));
            }
        },
        // Add Box Shadow when Search input is in focus
        searchInputFocus(){
            this.navSearchStyle = {"box-shadow": "0 0 0 2px rgb(99 102 241 / 75%)"};
        },
        // Remove Box Shadow when Search input is out of focus
        searchInputBlur(){
            this.navSearchStyle = {};
        },
        // Show Portrait Search Box
        showPortraitSearchBox(){
            this.portraitSearchStyle = {"display": "block"}
        },
        // Hide Portrait Search Box
        hidePortraitSearchBox(){
            this.portraitSearchStyle = {}
        },
        // Hide Search Results
        hideSearchResults(){
            this.portraitSearchDropdownStyle = {};
            this.searchDropdownStyle = {};
        },
        // Function to Toggle Sidebar
        toggleSideBar(){
            this.$refs["sidebar"].openSideBar();
        },
        // Get Cart Items from Local Storage
        getCartItems(){
            this.cartItemCount = 0;
            var cartItems = JSON.parse(localStorage.getItem("cartItems"));
            if(cartItems != null){
                for(let i=0;i<cartItems.length;++i){
                    this.cartItemCount = this.cartItemCount + parseInt(cartItems[i]["quantity"]);
                }
            }
        },
        // Perform Search
        performSearch(){
            if(this.searchVal.length > 0){
                const options = {includeScore: true, threshold: 0.3, keys: ['name', 'category', 'gender', 'color', 'collection'], shouldSort: true}
                const fuse = new Fuse(this.collectionsList, options)
            
                this.searchResult = (fuse.search(this.searchVal)).slice(0, 5);
                this.portraitSearchDropdownStyle = {"display": "block"};
                this.searchDropdownStyle = {"display": "block"};
            }
            else{
                this.portraitSearchDropdownStyle = {};
                this.searchDropdownStyle = {};
            }
        },
        // If user is logged in, go to account page, else redirect to Sign in page
        goToMyAccount(){
            if(this.uid!=undefined){
                window.location.href = "/account";
            }
            else{
                window.location.href = "/sign-in";
            }
        },
        // Show Mini Cart
        showMiniCart(){
            this.$refs["mini-cart"].openMiniCart();
        }
    }
}
</script>

<style scoped>
    /* Navbar */
    .navbar-wrapper{width: 100%;position: sticky;top: 0px;z-index: 11;}
    
    /* Navbar Main Bar */
    .nav-main-bar-wrapper{width: 100%;height: 70px;background-color: #fff;box-shadow: 0 0 #0000, 0 0 #0000, 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);}
    .nav-main-bar{display: grid;grid-template-columns: auto 1fr;max-width: 1280px;margin: auto;padding: 0 12px;}
    .nav-hamburger{fill: #3a3a3a;margin: 20px 0px;margin-right: 16px;width: 18px;height: 14px;display: none;cursor: pointer;}
    .nav-logo{height: 36px;width: 36px;margin: 17px 0;display: inline-block;cursor: pointer;}
    .nav-logo-text{font-size: 23px;font-weight: 600;vertical-align: middle;margin-left: 3px;color: #323567;}
    .nav-category-bar{display: inline-block;vertical-align: top;margin: 18px 0;margin-left: 32px;}
    .nav-category-list-box{display: flex;}
    .nav-category-list-item{padding: 8px 16px;font-size: 14px;font-weight: 500;cursor: pointer;user-select: none;}
    .nav-category-list-item:hover{border-bottom: 2px solid #6366f1;}
    .nav-category-list-item:hover:nth-child(3){border-bottom: none;}
    .nav-category-list-item:hover:nth-child(3) .nav-category-list-text{color: #6366f1;font-weight: 500;transition: 0.2s;}
    .nav-main-right{text-align: right;}
    .nav-cart-box{margin: 20px 0;padding: 4px;height: 22px;display: inline-block;cursor: pointer;position: relative;}
    .nav-cart-icon{width: 22px;height: 22px;display: inline-block;}
    .cart-item-count{font-weight: 500;position: absolute;right: 0;top: 0;border-radius: 50%;margin: 0;background-color: #de3d3d;color: #fff;font-size: 10px;width: 13px;height: 13px;text-align: center;line-height: 1.3;}
    .nav-account-box{margin: 20px;padding: 4px;height: 22px;display: inline-block;cursor: pointer;}
    .nav-account-icon{width: 22px;height: 22px;display: inline-block;}
    /* Nav Menu */
    .nav-category-list-text{margin: 0;}
    .nav-category-outer{position: absolute;left: 0;top: 50px;width: 100%;z-index: 10;pointer-events:none;opacity: 0;transition-delay: 1s; border-radius: 0 0 6px 6px;overflow: hidden;transition: 1s display;}
    .nav-category-sublist-box-wrapper{border: 1px solid #f1f1f1;max-width: 1280px;box-shadow: 0 10px 10px -5px rgb(0 0 0 / 4%);border-radius: 0 0 8px 8px;overflow: hidden;margin: auto;margin-top: 19px;}

    .nav-category-list-item:hover .nav-category-outer{pointer-events: auto;opacity: 1;transition: opacity 0.1s;transition-delay: 0.4s;}
    .nav-category-sublist-box-wrapper:hover{display: block;}

    .nav-category-sublist-box{display: grid;grid-template-columns: 3fr 2fr;position: relative;z-index: 1;background-color: #fff;}
    .sublist-item-col-wrapper{display: grid;text-align: left;grid-template-columns: 1fr 1fr 1fr;}
    .sublist-item-col{padding: 20px;padding-bottom: 40px;}
    .sublist-item-col:nth-child(2n+1){background-color: #fafafa;}
    .sublist-item-header{margin-top: 0px;margin-bottom: 16px;color: #161a23;font-weight: 500;}
    .sublist-item-text{padding: 8px 0;color: #7e7f8a;font-weight: 400;}
    .sublist-item-text:hover{color: #5c5d66;}
    .image-sublist-container{display: grid;grid-template-columns: 1fr 1fr;}
    .image-sublist-item{padding: 20px;}
    .image-sublist-wrapper{padding-bottom: 100%;background: #f1f1f1;position: relative;border-radius: 6px;overflow: hidden;}
    .image-sublist-img{position: absolute;top: 0;left: 0;width: 100%;height: 100%;object-fit: cover;border-radius: 6px;transition: all 0.2s;transition-timing-function: ease-out;}
    .image-sublist-title{color: #6366f1;font-size: 14px;padding: 4px 0;margin-top: 6px;font-weight: 600;line-height: 1.3;}
    .image-sublist-text{font-size: 14px;margin: 0;margin-top: 0;padding: 4px 0;color: #7e7f8a;font-weight: 400;}
    /* Nav Search */
    .nav-search-box-wrapper{margin: 12px 6px;padding: 4px;display: inline-block;cursor: pointer;vertical-align: top;}
    .nav-search-box{-webkit-appearance: none;-moz-appearance: none;appearance: none;padding: 0;font-size: 14px;border-bottom: 1px solid #e9edf1;width: 100%;font-weight: 500;color: #495057;display: flex;max-width: 400px;border-radius: 6px;border: 1px solid #e3e3e3;position: relative;}
    .nav-search-input{border: none;-webkit-appearance: none;-moz-appearance: none;appearance: none;background-color: rgba(0,0,0,0);border-color: #e2e8f0;border-width: 1px;padding: 8px 16px;font-size: 14px;line-height: 1.5;width: 100%;font-weight: 500;padding-right: 0;max-width: 400px;outline: none;box-sizing: border-box;color: #3a3a3a;}
    .nav-search-icon, .nav-search-icon-portrait{width: 23px;height: 23px;display: inline-block;margin: 7px;margin-right: 12px;}
    .nav-search-icon-portrait{display: none;}
    /* Nav Search Result */
    .nav-search-dropdown-wrapper, .nav-search-dropdown-wrapper-portrait{position: absolute;left: 0px;border-radius: 0 0 6px 6px;background-color: #fff;top: 38px;z-index: 3;width: 100%;box-shadow: 0 5px 10px -5px rgb(0 0 0 / 30%), 0 2px 5px -5px rgb(0 0 0 / 8%);transition: 0.4s;overflow: hidden;max-width: 400px;display: none;}
    .nav-search-dropdown-wrapper-portrait{top: 58px;padding: 0 10px;}
    .nav-search-dropdown{background-color: #fff;z-index: 3;position: relative;}
    .search-result-box{padding: 0px;}
    .nav-search-result-item{font-size: 14px;line-height: 20px;text-align: left;user-select: none;cursor: pointer;min-height: 38px;border-bottom: 1px solid #f1f1f1;}
    .nav-search-result-item:hover{background-color: #f6f6f6;}
    .nav-search-result-item a {padding: 8px 12px;width: 100%;display: block;}
    .nav-search-result-item:last-child{border-bottom: none;}
    .nav-search-dd-text{overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 1;-webkit-box-orient: vertical;word-break: break-all;}
    /* Portrait Search Box */
    .portrait-search-box-wrapper{position: absolute;width: 100%;top: 0px;left: 0;height: 70px;background-color: #fff;display: none;z-index: 1;}
    .portrait-search-box{padding: 6px;display: grid;grid-template-columns: 1fr 36px;overflow: hidden;max-width: unset;margin: 11px 4px;padding-right: 0px;}
    .search-input-box{width: 100%;}
    .portrait-input-box{font-size: 16px;}
    .search-icon-svg{position: relative;vertical-align: top;}
    .search-close-icon-svg{padding: 8px;width: 36px;height: 36px;cursor: pointer;}

    /* Tablet */
    @media only screen and (max-width: 1023px){
      .nav-hamburger{display: inline-block;}
      .nav-category-bar{display: none;}
      .nav-search-box{border: none;}
      .nav-search-dropdown-wrapper, .nav-search-input, .nav-search-icon{display: none;}
      .nav-search-icon-portrait{display: inline-block;}
      .nav-search-box-wrapper{margin: 13px 0px;}
      .nav-account-box{margin: 20px 5px;display: none;}
      .portrait-search-box{margin: 9px 4px;}
      .search-close-icon-svg{margin: 3px 0px;}
    }

</style>